// @ts-nocheck
import { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import { Error404 } from "./components/error/Error404";
import UserInfo from "./components/tabs/UserInfo";
import AccountSettings from "./components/tabsAdminInfo/AccountSettings";
import TableAdmin from "./components/tabsAdminManager/TableAdmin";

import Client from "./scenes/clients/Client";

import Login from "./scenes/login/Login";
import Logout from "./scenes/login/Logout";
import ResetPassword from "./scenes/login/ResetPassword";
import ResetPasswordForm from "./scenes/login/ResetPasswordForm";
import Landing from "./scenes/landing/Landing";

import Create from "./scenes/partner/Create";
import Dashboard from "./scenes/partner/Dashboard";
import { EachPartner } from "./scenes/partner/EachPartner";
import { TablePartner } from "./scenes/partner/TablePartner";

import Notifications from "./scenes/notifications/Notifications";
import NotificationsPartner from "./scenes/notifications/NotificationsPartner";

import Sb from "./scenes/sidebar/Sb";
import useAuthentication from "./scenes/useAuthentication";

import DashboardUser from "./userScenes/DashboardUser";
import ActiveRates from "./userScenes/clients/ActiveRatesUser";
import { Balance } from "./userScenes/clients/Balance";
import { Table } from "./userScenes/clients/Table";
import OficialSidebar from "./userScenes/sidebarUser/OficialSidebar";

function App() {
  const location = useLocation();

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [smallScreen, setSmallScreen] = useState(false);

  useAuthentication();

  const toggleSidebar = () => {
    setOpen((previousState) => !previousState);
  };

  useEffect(() => {
    const handleResize = () => {
      setSmallScreen(window.innerWidth < 768);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isLoginPage =
      location.pathname === "/" || location.pathname === "/login" || location.pathname.includes("/resetpassword");

  const isUserPath = location.pathname.startsWith("/user");
  const isAdminPath = location.pathname.startsWith("/admin");

  const shouldShowSidebar = !isLoginPage && (isUserPath || isAdminPath);

  const contentClassName = isLoginPage
      ? ""
      : smallScreen
          ? ""
          : open
              ? "ml-64 transition-all duration-300"
              : "ml-20 transition-all duration-300";

  return (
      <div className="App app-shell-background min-h-screen">
        {shouldShowSidebar && (
            <>
              {isUserPath && (
                  <OficialSidebar
                      sidebarOpens={sidebarOpen}
                      setSidebarOpens={setSidebarOpen}
                      opens={open}
                      onToggles={toggleSidebar}
                  />
              )}

              {isAdminPath && (
                  <Sb
                      sidebarOpens={sidebarOpen}
                      setSidebarOpens={setSidebarOpen}
                      opens={open}
                      onToggles={toggleSidebar}
                  />
              )}
            </>
        )}

        <main className={`${contentClassName} ${!isLoginPage ? "app-workspace" : ""}`}>
          <Routes>
            {/* Login / Recuperação de password */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/resetpassword" element={<ResetPassword />} />
            <Route path="/resetpassword/:token" element={<ResetPasswordForm />} />

            {/* Admin */}
            <Route path="/admin/dashboard" element={<Dashboard />} />
            <Route path="/admin/parceiros" element={<TablePartner />} />
            <Route path="/admin/parceiros/:id/edit" element={<EachPartner />} />
            <Route path="/admin/parceiros/:id/clientes" element={<Client />} />
            <Route path="/admin/admins" element={<TableAdmin />} />
            <Route path="/admin/notifications" element={<Notifications />} />
            <Route path="/admin/geral" element={<AccountSettings />} />
            <Route path="/admin/criar-parceiro" element={<Create />} />
            <Route path="/admin/logout" element={<Logout />} />

            {/* Parceiro */}
            <Route path="/user/dashboard" element={<DashboardUser />} />
            <Route path="/user/geral" element={<UserInfo />} />
            <Route path="/user/clientes" element={<Table />} />
            <Route path="/user/levantamento" element={<Balance />} />
            <Route path="/user/taxas" element={<ActiveRates />} />
            <Route path="/user/notifications" element={<NotificationsPartner />} />

            {/* Erros */}
            <Route path="/404" element={<Error404 />} />
            <Route path="/admin/error" element={<Error404 />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </main>
      </div>
  );
}

export default App;
